import * as React from 'react';
import { IObjectSearchResult } from 'services/search/search-reducer';
import { getOmjsProjectInstance } from 'selectors';
import { Project } from 'types/omjs/project';

export interface ISearchResultItemProps {
    item: IObjectSearchResult;
    onClick: (item: IObjectSearchResult) => any;
}
export interface ISearchResultItemState {}

class SearchResultItemComponent extends React.Component<ISearchResultItemProps, ISearchResultItemState> {
    project: Project;

    constructor(props: ISearchResultItemProps) {
        super(props);

        this.project = getOmjsProjectInstance(false);

        this.onItemClick = this.onItemClick.bind(this);
    }

    getIconUrl(item: IObjectSearchResult) {
        let iconUrl = item.layer_icon;

        if (iconUrl.length) {
            if (iconUrl.charAt(0) !== '/') {
                iconUrl = `/${iconUrl}`;
            }
            let port = this.project.apiUrlLocation.port ? `:${this.project.apiUrlLocation.port}` : '';
            /* eslint-disable-next-line */
            iconUrl = `${this.project.apiUrlLocation.protocol}//${this.project.apiUrlLocation.hostname}${port}${iconUrl}`;
        }
        return iconUrl;
    }

    onItemClick() {
        this.props.onClick(this.props.item);
    }

    render() {
        let { item } = this.props;
        return (
            <div onClick={this.onItemClick} className="result-item-wrapper">
                <div className="result-icon">
                    <img src={this.getIconUrl(item)} />
                </div>
                <div className="result-name">
                    {item.name}
                </div>
            </div>
        );
    }
}

export const SearchResultItem = SearchResultItemComponent;
